export default __webpack_public_path__ + "static/media/shutterstock_745960519.93822dac.webp";